import {RelativeTime} from '@primer/react'
import type {CertificateAttributes} from '../signed-commit-types'

import styles from './SmimeCommitFooter.module.css'

export default function SmimeCommitFooter({
  subject,
  issuer,
  signingLinkComponent,
  verifiedAt,
}: {
  subject: CertificateAttributes
  issuer: CertificateAttributes
  signingLinkComponent: React.ReactElement
  verifiedAt: string | undefined
}) {
  let subject_org_label = undefined
  if (subject.organization && subject.organization_unit) {
    subject_org_label = 'O/OU'
  } else if (subject.organization) {
    subject_org_label = 'O'
  } else if (subject.organization_unit) {
    subject_org_label = 'OU'
  }

  let issuer_org_label = undefined
  if (issuer.organization && issuer.organization_unit) {
    issuer_org_label = 'O/OU'
  } else if (issuer.organization) {
    issuer_org_label = 'O'
  } else if (issuer.organization_unit) {
    issuer_org_label = 'OU'
  }

  return (
    <div data-testid="smime-commit-footer" className="d-flex">
      <div className={styles.smimeDetailsContent}>
        <span className={styles.sectionHeading}>Certificate subject</span>
        <table className="mb-1">
          {subject.common_name && (
            <tr>
              <td className={styles.attributeLabel}>CN</td>
              <td className={styles.attributeValue}>{subject.common_name}</td>
            </tr>
          )}
          {subject.email_address && (
            <tr>
              <td className={styles.attributeLabel}>emailAddress</td>
              <td className={styles.attributeValue}>{subject.email_address}</td>
            </tr>
          )}
          {subject_org_label && (
            <tr>
              <td className={styles.attributeLabel}>{subject_org_label}</td>
              <td>
                {subject.organization}
                {subject_org_label === 'O/OU' && '/'}
                {subject.organization_unit}
              </td>
            </tr>
          )}
        </table>

        <span className={styles.sectionHeading}>Certificate issuer</span>
        <table className="mb-1">
          {issuer.common_name && (
            <tr>
              <td className={styles.attributeLabel}>CN</td>
              <td>{issuer.common_name}</td>
            </tr>
          )}
          {issuer_org_label && (
            <tr>
              <td className={styles.attributeLabel}>{issuer_org_label}</td>
              <td>
                {issuer.organization}
                {issuer_org_label === 'O/OU' && '/'}
                {issuer.organization_unit}
              </td>
            </tr>
          )}
        </table>

        {verifiedAt && (
          <div>
            Verified{' '}
            <RelativeTime datetime={verifiedAt} threshold="PT0S" year="numeric" hour="2-digit" minute="2-digit" />
          </div>
        )}

        {signingLinkComponent}
      </div>
    </div>
  )
}
